import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const Trigger = styled.span`
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  white-space: nowrap;
  cursor: pointer;
  background: transparent;
  padding: 0;

  color: ${(props) =>
    props.$red ? "#A80000" : props.$active ? "#A80000" : "rgb(75, 85, 99)"};

  font-family: "Avenir-Medium";
  font-size: 2rem;

  transition:
    color 0.15s,
    width 0.3s ease-in-out;

  &:hover {
    color: #484888;
  }
  @media (max-width: 768px) {
    font-size: 14px;

    color: ${(props) =>
      props.$red ? "#A80000" : props.$active ? "#fff" : "rgb(75, 85, 99)"};
    background: ${(p) => (p.$active ? "#4c4d93" : "#F3F4F6")};
    /* width: ${(p) => (p.$show ? "220px" : "fit-content")}; */
    padding: 8px 24px;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  width: ${(props) => props.$width}px;
  min-width: 220px;

  background: #ffffff;
  border: 1px solid #e8e8e8;

  box-shadow: 0 12px 32px rgba(72, 72, 136, 0.12);
  border-radius: 0 0 6px 6px;
  z-index: 200000;

  opacity: ${(props) => (props.$open ? 1 : 0)};
  visibility: ${(props) => (props.$open ? "visible" : "hidden")};
  transform: ${(props) => (props.$open ? "translateY(0)" : "translateY(-8px)")};
  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    visibility 0.18s;

  @media (max-width: 768px) {
    min-width: unset;
  }
`;

export const DropdownItemEl = styled.span`
  display: block;
  padding: 13px 20px;
  font-family: "Avenir-Medium", sans-serif;
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${(props) =>
    props.$red ? "#A80000" : props.$active ? "#484888" : "#423f3f"};
  font-weight: ${(props) => (props.$active ? "600" : "400")};
  background: ${(props) => (props.$active ? "#f4f4fb" : "transparent")};
  cursor: pointer;
  /* white-space: nowrap; */
  user-select: none;
  border-bottom: 1px solid #48488820;
  text-decoration: ${(props) => (props.$active ? "underline" : "none")};

  transition:
    background 0.12s,
    color 0.12s;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    opacity: ${(props) => (props.$active ? 1 : 0)};
    transition: opacity 0.12s;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f4f4fb;
    color: #484888;

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 1300px) {
    font-size: 1.3rem;
    padding: 11px 18px;
  }
`;
